var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"interactive",staticClass:"interactive",class:[{ focus: _vm.focus, jump: _vm.jump, disabled: _vm.disabled }, _vm.jumpSize],on:{"click":_vm.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }